import styled from 'styled-components';
import React from 'react';
import Row from '../../../../Common/Row';
import Tooltip from '../../../../Tooltip';

const CurrentPayCardDiv = styled.div`
  /* Card */

  box-sizing: border-box;

  /* Auto layout */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px 24px;
  gap: 8px;

  width: 100%;
  height: 154px;

  background-color: var(--color-bg-primary);
  border: 1px solid var(--color-border-primary);
  border-radius: 8px;

  /* Inside auto layout */
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`;

const CurrentPayCardDivInner = styled.div`
  /* Frame 8 */

  /* Auto layout */
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 4px;

  width: 100%;

  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;
`;

const Label1 = styled.span`
  /* Label */

  height: 16px;

  /* Body/Label */
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  /* identical to box height */
  text-align: center;

  color: var(--color-text-secondary);

  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;
`;

const Label2 = styled.span`
  /* Value */

  height: 34px;

  /* Header/H1 */
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 34px;
  /* identical to box height */
  text-align: center;

  color: var(--color-text-primary);

  /* Inside auto layout */
  flex: none;
  order: 1;
  flex-grow: 0;
`;

const Label3 = styled.span`
  /* Label */

  height: 16px;

  /* Body/Label */
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  /* identical to box height */
  text-align: center;

  color: var(--color-text-secondary);

  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;
`;

const CurrentPayCard = ({
  label,
  current,
  available,
  TooltipContent,
}: {
  label: string;
  current: string;
  available: string;
  TooltipContent: JSX.Element | undefined;
}) => {
  return (
    <CurrentPayCardDiv>
      <CurrentPayCardDivInner>
        <div>
          <Label1>{label}</Label1>
        </div>
        <Tooltip content={TooltipContent}>
          <div>
            <Label2>{current}</Label2>
          </div>
        </Tooltip>
        <Row style={{ gap: 4 }}>
          <Label3>{`Total available ${available}`} </Label3>
        </Row>
      </CurrentPayCardDivInner>
    </CurrentPayCardDiv>
  );
};

export default CurrentPayCard;
